import Icon from '../Icon.vue'

Icon.register({
  'pdf': {
    width: 20,
    height: 20,
    paths: [
      {
        d: 'M10 5V2.824L12.176 5H10zm.003-5H1a1 1 0 00-1 1v18a1 1 0 001 1h13a1 1 0 001-1v-3h-2v2H2V2h6v4a1 1 0 001 1h4v2h2V4.997L10.003 0z'
      },
      {
        d: 'M9.863 11.102H9.17v1.008h.693c.336 0 .532-.244.532-.503 0-.26-.196-.505-.532-.505zm.057 2.107h-.75v1.78H7.944v-4.987H9.92c1.106 0 1.701.785 1.701 1.604 0 .82-.595 1.604-1.7 1.604zM14.547 11.375c-.112-.168-.28-.28-.59-.28h-.538v2.801h.539c.309 0 .477-.112.589-.28.098-.139.133-.272.133-1.12 0-.841-.035-.98-.133-1.121zm.84 3.124c-.343.343-.826.49-1.345.49h-1.85v-4.986h1.85c.519 0 1.002.146 1.345.49.582.581.518 1.219.518 2.003s.064 1.422-.518 2.003zM17.836 11.095v.876h1.85v1.093h-1.85v1.926H16.61v-4.987H20v1.092h-2.164z'
      }
    ]
  }
})
